import { Stars } from 'darrius';

interface ICleanCardRating {
  ratingNumber: number;
}
export function CleanCardRating({ ratingNumber }: ICleanCardRating) {
  return <Stars rating={ratingNumber} size="small" />;
}
